export const setSubControlsDisabled = (container, disabled) => {
  if (!container) return;
  container.querySelectorAll("input, select, textarea").forEach((el) => {
    el.disabled = disabled;
  });
};

export const toggleSubControls = (containerId, show) => {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.style.display = show ? "block" : "none";
  setSubControlsDisabled(container, !show);
};
